<template>
    <el-container id="app">

        <!-- Cabecera -->
        <el-header style="margin-top:10px">
            <Header></Header>
        </el-header>

        <!-- Cuerpo -->
        <el-main style="margin-top:4%; min-height:71vh">
            <Menu></Menu>
            <router-view></router-view>
        </el-main>

        <!-- Footer -->
        <el-footer style="margin-bottom:30px">
            <Footer></Footer>
        </el-footer>

    </el-container>
</template>



<script>
    import Header      from './components/Header.vue';
    import Menu        from './components/Menu.vue';
    import Footer      from './components/Footer.vue';

    export default
    {   components:
        {   Header,
            Menu,        
            Footer
        },
        data()
        {   return {
            }
        }
    };
</script>



<style>    
    #app
    {   -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei",Arial,sans-serif;
        font-size: 16px;
        max-width: 100vw !important;
        overflow: hidden;
    }
    body
    {   background: url("./assets/Fondo.jpg");
        background-attachment: fixed;
        background-position: bottom;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .titulo
    {   background: #788EDC;
        padding: 30px;
        margin-bottom: -30px;
        color: #fff;
        font-size: large;
        text-align: center;
        -webkit-box-shadow: 0px 2px 10px 0px rgba(50, 50, 50, 0.75);
        -moz-box-shadow:    0px 2px 10px 0px rgba(50, 50, 50, 0.75);
        box-shadow:         0px 2px 10px 0px rgba(50, 50, 50, 0.75);
        z-index: 1;
    }
    .cuerpo
    {   padding: 50px 30px 30px 30px;
        border-radius: 0px;
        background-color: rgba(255, 255, 255, 0.35);
        -webkit-box-shadow: 0px 5px 20px 0px #666;
        -moz-box-shadow: 0px 5px 20px 0px #666;
        box-shadow: 0px 5px 20px 0px #666;
        margin-bottom: 50px;
        text-align: justify;
    }
    .el-col
    {   padding-left: 30px !important;
        padding-right: 30px !important;
    }
    a
    {   text-decoration: none;
    }
    th, tr
    {   text-align: center !important;
    }
    hr
    {   margin-top: 10px;
        margin-bottom: 10px;
    }
    button, button:hover, a, a:hover
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
        text-decoration: none;
    }



/** VUETIFY ********************************************************************************************************/
    .theme--light.application
    {   background: none !important;    
    }
    .v-text-field.v-text-field--solo .v-input__control, .v-input__control
    {   min-height: 40px;
        height: 40px;
    }
    .v-input__slot
    {   background: #eee !important;
    }



/** DISPLAY ********************************************************************************************************/
    @media (max-width:767px)
    {	  .hidden-xs
        {	  display: none !important;
        }
        .visible-xs
        {	  display: block !important;
        }
        .visible-sm
        {	  display: none !important;
        }
        .visible-md
        {	  display: none !important;
        }
        .visible-lg
        {	  display: none !important;
        }
    }
    @media (min-width:768px) and (max-width:991px)
    {	  .hidden-sm
        {   display: none !important
        }
        .visible-xs
        {	  display: none !important;
        }
        .visible-sm
        {	  display: block !important;
        }
        .visible-md
        {	  display: none !important;
        }
        .visible-lg
        {	  display: none !important;
        }
    }
    @media (min-width:992px) and (max-width:1199px)
    {	  .hidden-md
        {	  display: none !important
        }
        .visible-xs
        {	  display: none !important;
        }
        .visible-sm
        {	  display: none !important;
        }
        .visible-md
        {	  display: block !important;
        }
        .visible-lg
        {	  display: none !important;
        }
    }
    @media (min-width:1200px)
    {	  .hidden-lg
        {	  display: none !important
        }
        .visible-xs
        {	  display: none !important;
        }
        .visible-sm
        {	  display: none !important;
        }
        .visible-md
        {	  display: none !important;
        }
        .visible-lg
        {	  display: block !important;
        }
    }
</style>